<template>
  <div class="gc-levels" :class="{anchor: anchorStyling}">
    <div
      aria-hidden="true"
      class="levels-meter"
      :class="{locked: blurLock, 'line-up': gradeContainsAdultTransition}"
      v-if="showLevel">
      <div class="bubbles">
        <div
          class="bubble"
          :key="index"
          :class="{active: l === level, locked: blurLock}"
          v-for="(l, index) of levels" />
      </div>
    </div>
    <span
      v-if="showLevel"
      :class="{locked: blurLock}"
      class='level-label'>{{ levelLabel || level }}</span>
    <span class="level-value" :class="{'space-left': true, 'locked': blurLock, 'break-text': gradeContainsAdultTransition}">{{ gradeLabelIfAccess }}</span>
  </div>
</template>

<script>
import { getPlaceholderText } from '@/util/placeholder_text'
import { gradesToLabels } from '@/util/gradesort'

export default {
  name: 'GoalCardLevelIndicators',
  props: {
    grades: {
      type: Array,
      required: true
    },
    level: {
      type: String,
      default: ''
    },
    levelLabel: {
      type: String,
      default: ''
    },
    levels: {
      type: Array,
      default: () => []
    },
    anchorStyling: {
      type: Boolean,
      default: false
    },
    blurLock: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showLevel() {
      return this.levels && this.levels.length > 0
    },
    gradeLabel() {
      const grades = gradesToLabels(this.grades)
      let label = `Grade ${(grades.length > 1 &&
        grades[0] + '-' + grades[grades.length - 1]) ||
        grades[0]}`

      if (grades[0] === 'Birth-3' || grades[0] === 'Pre-K' || grades[0] === 'Adult Transition') {
        label = label.replace('Grade ', '')
      }
      return label
    },
    gradeLabelIfAccess() {
      if (this.blurLock) {
        return getPlaceholderText(8)
      }
      return this.gradeLabel
    },
    gradeContainsAdultTransition() {
      return this.grades.length > 1 && this.grades.includes('Adult-Transition')
    }
  }
}
</script>

<style lang="less" scoped>
@import './colors.less';

.gc-levels {
  display: flex;
  justify-content: space-between;
  align-items: start;
  color: @textPrimary;
  font-size: 10px;
  font-weight: bold;

  .levels-meter {
    align-self: center;
    margin-top: -7px;
    flex-shrink: 0;
    margin-right: 1em;
    position: relative;
    height: 8px;
    border-bottom: 1px solid @outlinePrimary;

    .bubbles {
      .bubble {
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        border: 1px solid @outlinePrimary;
        background: @legacyBackground;
        margin-right: 15px;

        &:last-child {
          margin-right: 0;
        }
        &.active {
          background: @outlinePrimary;
        }
        &.locked {
          filter: blur(5px);
        }
      }
    }
    &.locked{
      border-bottom: none;
    }
    &.line-up{
      margin-top: 0px;
      align-self: start;
    }
  }
  &.anchor {
    color: @anchorPrimary;
    .levels-meter {
      border-color: @anchorPrimary;
      .bubbles {
        .bubble {
          border-color: @anchorPrimary;
          background: @anchorBackground;
          &.active {
            background: @anchorPrimary;
          }
        }
      }
    }
  }
  .space-left {
    margin-left: auto;
  }
}
.break-text {
  word-break: keep-all;
  overflow-wrap: anywhere;
  flex-shrink: 1;
  text-align: right;
  text-wrap: balance;
  margin-top: -4px;
}
.level-label {
  flex-shrink: 0;
}
</style>
